export const SET_GROUP_STRUCTURE = 'SET_GROUP_STRUCTURE';
export const SET_GROUP_STRUCTURE_BY_COMPANY = 'SET_GROUP_STRUCTURE_BY_COMPANY';
export const SET_GROUP_STRUCTURE_DAFULTS = 'SET_GROUP_STRUCTURE_DAFULTS';
export const SET_LOADING_ON = 'SET_LOADING_ON';
export const SET_LOADING_OFF = 'SET_LOADING_OFF';
